import { Box } from "@mui/material";
import { ReferenceField, TextField } from "react-admin";

import { erasmusRequests } from "api/erasmusApi";

const StatusHeader = () => (
  <Box sx={{ textAlign: "end", width: "96%", paddingY: "1rem" }}>
    <ReferenceField
      label="Статус"
      source="status"
      reference={erasmusRequests.getApplicationStatusesSelect()}
    >
      <TextField
        color={theme => theme.palette.primary.main}
        fontWeight={"bold"}
        sx={{ fontSize: "16px" }}
        source="nameBg"
        emptyText="-"
      />
    </ReferenceField>
  </Box>
);

export default StatusHeader;
